import { MessageDescriptor } from 'react-intl';

import messages from './messages';
import { ConditionOperator, ContractType, FieldKind } from './types';

// Values are message descriptors, not display text — translate at render
// time via intl.formatMessage, same as every other visible label in this
// container.
export const CONTRACT_TYPE_LABELS: Record<ContractType, MessageDescriptor> = {
  full_time: messages.contractTypeFullTime,
  part_time: messages.contractTypePartTime,
  contract: messages.contractTypeContract,
  temporary: messages.contractTypeTemporary,
  seasonal: messages.contractTypeSeasonal,
};

// Only .docx is accepted: OfferLetterTemplateUploader#extension_allowlist permits
// `docx` only. PDF-only upload override is deferred to AXHE-3720; advertising .pdf
// here would let a drop/upload 500 on the backend with an opaque error.
export const ACCEPTED_UPLOAD_TYPES = '.docx';

export const CONDITIONAL_KIND: FieldKind = 'conditional_toggle';

// Signature placeholders auto-resolve to a Dropbox Sign text tag at render time
// (no admin mapping, no value), so they don't belong in the Variables rail's
// "map a value" list. Authoring/placement lives in the Signatures rail (and
// AXHE-3751). AXHE-3852 review.
export const SIGNATURE_KIND: FieldKind = 'signature';

// Kinds an admin can assign to a non-conditional variable.
export const EDITABLE_FIELD_KINDS: Exclude<FieldKind, 'conditional_toggle'>[] = [
  'auto_readonly',
  'manual_entry',
  'free_text',
];

// Mirrors OfferLetterTemplateFieldCondition::OPERATORS.
export const CONDITION_OPERATORS: ConditionOperator[] = [
  'equals',
  'not_equals',
  'present',
  'blank',
  'greater_than',
  'less_than',
  'contains',
];

// Presence-only operators — value input hidden. Mirrors VALUELESS_OPERATORS.
export const VALUELESS_OPERATORS: ConditionOperator[] = ['present', 'blank'];
